import { useEffect, useState } from "react";
import Swal from "sweetalert2";

export const UserNameComponent = ({ phone, setPhone }) => {
  const [isPhoneValid, setIsPhoneValid] = useState(false);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 11) {
      setPhone(value);
      if (value.length === 0 && !isPhoneValid) setIsPhoneValid(true);
      else if (value.length === 11 && isPhoneValid) setIsPhoneValid(false);
    }
  };
  return (
    <div className="row form-group signin-username">
      <label
        for="username"
        class="col-form-label col-md-3 text-md-left signin-username-label"
      >
        شماره همراه
      </label>
      <div className="col-12">
        <input
          onChange={handlePhoneChange}
          type="text"
          value={phone}
          maxLength={11}
          name="username"
          className="form-control signin-username-input text-left"
          placeholder="شماره همراه"
        />
        <div
          className={
            "validation-inline signin-inline-error text-danger" +
            (!isPhoneValid ? " d-none" : "")
          }
        >
          <span> شماره تلفن را وارد کنید! </span>
        </div>
      </div>
    </div>
  );
};

export const ActiveCodeComponent = ({ activeCode, goToNextSlide }) => {
  const [isValidActiveCode, setIsValidActiveCode] = useState(false);
  const [activeCodeInput, setActiveCodeInput] = useState("");

  const handleActiveCodeChange = (e) => {
    const value = e.target.value;

    if (/^\d*$/.test(value)) {
      setActiveCodeInput(value);
      if (value.length === 6) {
        if (Number(value) === activeCode) {
          setIsValidActiveCode(false);
          goToNextSlide();
        } else {
          setIsValidActiveCode(true);
          Swal.fire({
            icon: "error",
            title: "خطا",
            text: "کد وارد شده معتبر نیست!",
            confirmButtonText: "باشه",
          }).then(() => {
            setActiveCodeInput("");
          });
        }
      } else if (isValidActiveCode) setIsValidActiveCode(false);
    }
  };

  return (
    <div className="row form-group signin-username">
      <label
        htmlFor="activeCode"
        className="col-form-label col-md-3 text-md-left signin-username-label"
      >
        کد ارسال شده
      </label>
      <div className="col-12">
        <input
          onChange={handleActiveCodeChange}
          type="text"
          value={activeCodeInput}
          maxLength={6}
          name="activeCode"
          className="form-control signin-username-input text-center"
          placeholder="کد تایید"
        />
        <div
          className={
            "validation-inline signin-inline-error text-danger" +
            (!isValidActiveCode ? " d-none" : "")
          }
        >
          <span> کد ارسالی را وارد کنید </span>
        </div>
      </div>
    </div>
  );
};

export const PasswordComponent = ({ password, setPassword }) => {
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (value.length === 0 && !isPasswordValid) setIsPasswordValid(true);
    else if (value.length >= 6 && isPasswordValid) setIsPasswordValid(false);
  };

  return (
    <div className="row form-group signin-password">
      <label
        for="password"
        class="col-form-label col-md-3 text-md-left signin-password-label"
      >
        رمز عبور
      </label>
      <div className="col-12">
        <input
          type="password"
          value={password}
          onChange={handlePasswordChange}
          className="form-control signin-password-input text-left"
          placeholder="رمز عبور"
          name="password"
        />
        <div
          className={
            "validation-inline signin-inline-error text-danger" +
            (!isPasswordValid ? " d-none" : "")
          }
        >
          <span> رمز عبور حداقل 6 رقم است ! </span>
        </div>
      </div>
    </div>
  );
};

export const ConfirmPasswordComponent = ({ setPassword }) => {
  const [passwordInput, setPasswordInput] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isMatchValid, setIsMatchValid] = useState(false);

  const validatePasswords = (password, confirmPassword) => {
    const isValid =
      password.length >= 6 &&
      confirmPassword.length >= 6 &&
      password === confirmPassword;
    setPassword({ valid: isValid, value: password });
    setIsMatchValid(password === confirmPassword);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPasswordInput(value);

    setIsPasswordValid(value.length >= 6);
    validatePasswords(value, confirmPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    validatePasswords(passwordInput, value);
  };

  return (
    <>
      <div className="row form-group signin-password">
        <label
          htmlFor="password"
          className="col-form-label col-md-3 text-md-left signin-password-label"
        >
          رمز عبور
        </label>
        <div className="col-12">
          <input
            type="password"
            value={passwordInput}
            onChange={handlePasswordChange}
            className="form-control signin-password-input text-left"
            placeholder="رمز عبور"
            name="password"
          />
          <div
            className={
              "validation-inline signin-inline-error text-danger" +
              (isPasswordValid || passwordInput.length === 0 ? " d-none" : "")
            }
          >
            <span> رمز عبور حداقل 6 رقم است ! </span>
          </div>
        </div>
      </div>
      <div className="row form-group signin-password">
        <label
          htmlFor="confirmPassword"
          className="col-form-label col-md-3 text-md-left signin-password-label"
        >
          تکرار رمز عبور
        </label>
        <div className="col-12">
          <input
            type="password"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            className="form-control signin-password-input text-left"
            placeholder="تکرار رمز عبور"
            name="confirmPassword"
          />
          <div
            className={
              "validation-inline signin-inline-error text-danger" +
              (isMatchValid || confirmPassword.length === 0 ? " d-none" : "")
            }
          >
            <span> رمز عبور و تکرار آن یکسان نیستند! </span>
          </div>
        </div>
      </div>
    </>
  );
};

export const TimerComponent = ({ onSendCode }) => {
  const [timeLeft, setTimeLeft] = useState(60);
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleClick = () => {
    if (timeLeft > 0) return;
    setTimeLeft(60);
    if (onSendCode) onSendCode();
  };

  return (
    <button
      type="button"
      className="btn btn-lg btn-primary signin-submit shadow"
      style={{ padding: "0.4625rem 1.1875rem" }}
      onClick={handleClick}
      disabled={timeLeft > 0}
    >
      {timeLeft > 0 ? `ارسال مجدد کد (${timeLeft}s)` : "ارسال کد"}
    </button>
  );
};
